import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../../../../theme/types';
import {Column, Row} from '../../common/Layouts/Layouts';
import Image from '../../common/Image/Image';
import NewImageIcon from '../../../../Icons/NewImageIcon';

export const WrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
`,
);

export const MainImageWrapperDivStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  height: 24rem;
`;

export const ImageStyle = styled(Image)(
  props => `
  display: flex;
  height: 24rem;
  width: 24rem;
  object-fit: cover;
  border-radius: .4rem;
`,
);

const IconWrapper = styled.div(
  props => `
    display: flex;
    background: #f7f5f5;
    position: absolute;
    bottom: 0;
    width: 4.2rem;
    height: 3.5rem;
    border-radius: ${props.theme.misc.borderRadius.base}
    text-align: center;
    justify-content: center;
    // &:hover {
    //   background-color: #f4faff;
    // }
  `
)

export const IconWrapperRight = styled(IconWrapper)(
  props => `
    right: 1%;
    // border-radius: ${props.theme.misc.borderRadius.base} 0 ${props.theme.misc.borderRadius.base} 0;
    /* top: 50%;
    right: 12%; */
  `
);

export const IconWrapperLeft = styled(IconWrapper)(
  props => `
  left: 1%;
  // border-radius: 0 ${props.theme.misc.borderRadius.base} 0 ${props.theme.misc.borderRadius.base};
  /* top: 50%;
  left: 5%; */
`
);


export const UnstyledDiv = styled.div(
    props => `
    position:absolute;
    left:-3%;
    top:-3%;
    border-radius:2px;
    display: inline-block;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(75deg, #339933, #33cc33);
    height : 20px;
    text-align: center;
    line-height:1.6;
    font-weight:900;
    color:white;
    padding : 0px 3px;
    &:after {
        content: "";
        border-top: 0.5rem solid rgb(24, 161, 96);
        border-left: 0.7rem solid transparent;
        position: absolute;
        left: 0px;
        top: 1.8rem;
    }
  `
  );

export const MiniImageStyle = styled(Image)(
  props => `
  display: flex;
  object-fit: cover;
  border-radius: ${props.theme.misc.borderRadius.base};
  height: 4.5rem;
  width: 4.5rem;
`,
);

export const ImageListWrapperStyle = styled.div(
  props => `
  align-items: center;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  // z-index: ${props.theme.misc.zIndex.large};
`,
);

export const NoImageListIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.blue.bgBlue};
  width: ${props => props.width || '4.5rem'};
  height: ${props => props.height || '4.5rem'};
  border-radius: ${props => props.theme.misc.borderRadius.base};
`;

export const ImageList = styled.ul`
  width: 100%;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  /* padding-top: ${props => props.theme.spacing.base}; */
  > li {
    width: 4.5rem;
    height: 4.5rem;
    display: inline-flex;
    border-radius: ${props => props.theme.misc.borderRadius.base};
    margin-right: 0.5rem;
    cursor: pointer;
    background: ${props => (props.isNewListing ? `${props.theme.colors.blue.bgBlue};` : '')}
    &: last-child {
      margin-right: 0;
    }
  }
`;

export const ViewAllWrapperStyle = styled.div(
  props => `
  display: flex;
  position: absolute;
  bottom: ${props.theme.spacing.small.s6};
  right: ${props.theme.spacing.small.s5};
  top: 0rem;
  border-radius: ${props.theme.misc.borderRadius.base};
  width: 4.5rem;
  height: 4.5rem;
  align-items: center;
  justify-content: center;
  background-color: ${props.theme.colors.shadow.dark};
  cursor: pointer;
`,
);

export const ViewAllTextStyle = styled.span(
  props => `
  color: ${props.theme.colors.white.base};
  line-height: 1.3;
  font-size: ${props.theme.font.base};
  text-align: center;
  text-transform: uppercase;
`,
);

export const GoStaysIconWrapperForImageListDiv = styled(Column)`
  background-color: ${props => props.theme.colors.goBrand.blue};
  height: 4.5rem;
  width: 4.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
`;

export const GoStaysIconWrapperForImageListSpan = styled.span`
  width: 3.4rem;
  height: 3.4rem;
  background-color: white;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 0.1rem solid white;
`;

export const NewThumbnailIcon = styled(NewImageIcon)(
  props => `

  color:${props.theme.colors.grey.grey75};
  cursor:pointer;
  width: 4rem;
  height: 4rem;
  margin-top:${props.theme.spacing.large.l15};
  margin-left:${props.theme.spacing.base};

`,
);
